/* Admin helper for the Laser Library Upload page. */
(function () {
  "use strict";

  const KEY = "cre1ative2mon3umen8t4web5site6bui4ldin9g7edi67tor3";
  const BASE = "https://cm-editor-server.onrender.com";
  const LIST_API = `${BASE}/api/laser-library?key=${KEY}`;
  const UPLOAD_API = `${BASE}/api/laser-library/upload?key=${KEY}`;
  const DELETE_API = `${BASE}/api/laser-library/file?key=${KEY}`;

  let allItems = [];
  const selectedKeys = new Set();

  function byId(id) {
    return document.getElementById(id);
  }

  function setOut(message) {
    const out = byId("cm_laser_upload_out");
    if (out) out.textContent = typeof message === "string" ? message : JSON.stringify(message, null, 2);
  }

  function clearOutSoon() {
    window.setTimeout(() => {
      const out = byId("cm_laser_upload_out");
      if (out) out.textContent = "";
    }, 2200);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function itemLabel(item) {
    return `${item.name || "Laser Design"} - ${item.type || ""} / ${item.category || ""} / ${item.subcategory || ""}`;
  }

  function normalizeType(value) {
    return String(value || "").trim().toLowerCase() === "scene" ? "scene" : "spot";
  }

  function sameText(a, b) {
    return String(a || "").trim().toLowerCase() === String(b || "").trim().toLowerCase();
  }

  function uniqueSorted(values) {
    const map = new Map();
    values.forEach((value) => {
      const label = String(value || "").trim();
      if (!label) return;
      const key = label.toLowerCase();
      if (!map.has(key)) map.set(key, label);
    });
    return Array.from(map.values()).sort((a, b) => a.localeCompare(b));
  }

  function fillDatalist(id, values) {
    const list = byId(id);
    if (!list) return;
    list.innerHTML = "";
    values.forEach((value) => {
      const option = document.createElement("option");
      option.value = value;
      list.appendChild(option);
    });
  }

  function updateCategoryChoices() {
    const type = normalizeType(byId("cm_laser_type")?.value);
    const categories = uniqueSorted(
      allItems
        .filter((item) => normalizeType(item.type) === type)
        .map((item) => item.category)
    );
    fillDatalist("cm_laser_category_list", categories);
    updateSubcategoryChoices();
  }

  function updateSubcategoryChoices() {
    const type = normalizeType(byId("cm_laser_type")?.value);
    const category = byId("cm_laser_category")?.value || "";
    const subcategories = uniqueSorted(
      allItems
        .filter((item) => normalizeType(item.type) === type)
        .filter((item) => !category || sameText(item.category, category))
        .map((item) => item.subcategory)
    );
    fillDatalist("cm_laser_subcategory_list", subcategories);
  }

  async function fetchLibrary() {
    const res = await fetch(LIST_API, { cache: "no-store" });
    const data = await res.json();
    allItems = Array.isArray(data.items) ? data.items : [];
    updateCategoryChoices();
    return allItems;
  }

  function renderSearchResults() {
    const list = byId("cm_laser_library_results");
    const q = String(byId("cm_laser_search")?.value || "").trim().toLowerCase();
    const deleteBtn = byId("cm_laser_delete_btn");
    selectedKeys.clear();
    if (deleteBtn) deleteBtn.disabled = true;
    if (!list) return;

    if (!q) {
      list.innerHTML = "<div style=\"font-weight:900;opacity:.7;\">Type a file name, category, or subcategory to search.</div>";
      return;
    }

    const matches = allItems
      .filter((item) => {
        const hay = [item.name, item.type, item.category, item.subcategory, item.key].join(" ").toLowerCase();
        return hay.includes(q);
      })
      .slice(0, 50);

    if (!matches.length) {
      list.innerHTML = "<div style=\"font-weight:900;opacity:.7;\">No matches.</div>";
      return;
    }

    list.innerHTML = "";
    matches.forEach((item) => {
      const row = document.createElement("label");
      row.style.cssText = [
        "display:grid",
        "grid-template-columns:22px 76px 1fr",
        "gap:10px",
        "align-items:center",
        "border:1px solid #ddd",
        "border-radius:12px",
        "padding:10px",
        "background:#fff",
        "cursor:pointer"
      ].join(";");

      row.innerHTML = `
        <input type="checkbox" name="cm_laser_delete_choice" value="${escapeHtml(item.key)}">
        <img src="${escapeHtml(item.url)}" alt="" style="width:76px;height:64px;object-fit:contain;background:#f5f5f5;border-radius:8px;">
        <div style="min-width:0;">
          <div style="font-weight:900;">${escapeHtml(itemLabel(item))}</div>
          <div style="font-size:11px;color:#666;word-break:break-all;">${escapeHtml(item.key)}</div>
        </div>
      `;

      row.querySelector("input").addEventListener("change", (event) => {
        const key = String(event.target.value || "");
        if (event.target.checked) selectedKeys.add(key);
        else selectedKeys.delete(key);
        if (deleteBtn) deleteBtn.disabled = selectedKeys.size === 0;
      });

      list.appendChild(row);
    });
  }

  async function refreshLibrary() {
    const list = byId("cm_laser_library_results");
    if (list) list.innerHTML = "<div style=\"font-weight:900;opacity:.7;\">Loading index...</div>";
    try {
      await fetchLibrary();
      renderSearchResults();
    } catch (e) {
      if (list) list.innerHTML = `<div style="font-weight:900;color:#b00020;">Could not load library: ${escapeHtml(e.message || e)}</div>`;
    }
  }

  async function deleteSelected() {
    const keys = Array.from(selectedKeys);
    if (!keys.length) {
      setOut("Search for files and select one or more first.");
      return;
    }
    const labels = keys
      .map((key) => allItems.find((it) => String(it.key || "") === key))
      .filter(Boolean)
      .map(itemLabel);
    const ok = confirm(`Delete ${keys.length} selected laser library file${keys.length === 1 ? "" : "s"}?\n\n${labels.slice(0, 8).join("\n")}${labels.length > 8 ? "\n..." : ""}`);
    if (!ok) return;

    setOut(`Deleting ${keys.length} file${keys.length === 1 ? "" : "s"}...`);
    try {
      const deleted = [];
      const failed = [];

      for (const key of keys) {
        const res = await fetch(`${DELETE_API}&fileKey=${encodeURIComponent(key)}`, {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ key })
        });
        const txt = await res.text();
        let data = {};
        try { data = JSON.parse(txt); } catch (_) { data = { raw: txt }; }
        if (res.ok && data.ok !== false) deleted.push(key);
        else failed.push({ key, status: res.status, ...data });
      }

      setOut(failed.length
        ? { deleted: deleted.length, failed }
        : `Deleted ${deleted.length} file${deleted.length === 1 ? "" : "s"}.`);
      await refreshLibrary();
      if (!failed.length) clearOutSoon();
    } catch (e) {
      setOut("Delete failed:\n" + (e && e.message ? e.message : String(e)));
    }
  }

  async function upload() {
    const files = byId("cm_laser_files")?.files;
    if (!files || !files.length) {
      setOut("Choose one or more files first.");
      return;
    }

    const fd = new FormData();
    fd.append("type", byId("cm_laser_type")?.value || "spot");
    fd.append("category", byId("cm_laser_category")?.value || "Uncategorized");
    fd.append("subcategory", byId("cm_laser_subcategory")?.value || "");
    Array.from(files).forEach((file) => fd.append("files", file));

    setOut("Uploading...");
    try {
      const res = await fetch(UPLOAD_API, { method: "POST", body: fd });
      const txt = await res.text();
      let data = {};
      try { data = JSON.parse(txt); } catch (_) { data = { raw: txt }; }
      setOut({ status: res.status, ...data });
      if (res.ok && byId("cm_laser_files")) byId("cm_laser_files").value = "";
      await refreshLibrary();
      if (res.ok) clearOutSoon();
    } catch (e) {
      setOut("Upload failed:\n" + (e && e.message ? e.message : String(e)));
    }
  }

  function init() {
    byId("cm_laser_upload_btn")?.addEventListener("click", upload);
    byId("cm_laser_refresh_btn")?.addEventListener("click", refreshLibrary);
    byId("cm_laser_search")?.addEventListener("input", renderSearchResults);
    byId("cm_laser_delete_btn")?.addEventListener("click", deleteSelected);
    byId("cm_laser_type")?.addEventListener("change", updateCategoryChoices);
    byId("cm_laser_category")?.addEventListener("input", updateSubcategoryChoices);
    refreshLibrary();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
